import { useEffect, useState } from 'react';

import {
  Button,
  ButtonElementTypes,
  ButtonSkinTertiary,
} from '@picsart/design-system/components/Button';
import Title from '@picsart/growth-rc/Title';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import { useTranslator } from '@picsart/rc/services/localization';
import useDevice from 'hooks/useDeviceType';

import usePageDataStore from 'stores/pageDataStore';
import { StrapiLandingBaseModel } from 'strapi/types';
import { defaultLanguage } from 'constants/languages';
import Tool from './Tool';
import useStyles from './styles';
import { AllToolsProps } from './types';

function AllTools({ title, buttonLabel }: Readonly<AllToolsProps>) {
  const styles = useStyles();
  const translate = useTranslator();
  const { isDesktop } = useDevice();
  const sliceLength = isDesktop ? 32 : 16;
  const [slicedTools, setSlicedTools] = useState(sliceLength);
  const [filterCategory] = useState('All');
  const pageData = usePageDataStore(x => x.pageData);
  const [landings, setLandings] = useState<StrapiLandingBaseModel[]>();

  useEffect(() => {
    setLandings(pageData?.data?.landings?.filter(landing => landing.locale === defaultLanguage));
  }, [pageData]);

  const filteredTools = landings?.filter(
    tool => filterCategory === 'All' || tool.category === filterCategory,
  );
  const isShowMoreVisible = filteredTools?.slice(0, slicedTools)?.length < filteredTools?.length;

  return (
    <section data-pulse-section-group="all-tools">
      <HorizontalContainer className={styles.wrapper}>
        <Title {...title} className={styles.title} />
        {/* the comment must be uncommented when the category is set */}
        {/* <AllToolsNavigation */}
        {/*   navItems={ */}
        {/*     [ */}
        {/*       // 'All', */}
        {/*       // ...landings */}
        {/*       //   ?.map(tool => tool.category) */}
        {/*       //   ?.filter((item, index, array) => array.indexOf(item) === index), */}
        {/*     ] */}
        {/*   } */}
        {/*   filterCategory={filterCategory} */}
        {/*   handleChange={handleChange} */}
        {/*   mobileHeaderTitle={mobileHeaderTitle} */}
        {/*   mobilePopupTitle={mobilePopupTitle} */}
        {/* /> */}
        <div className={styles.grid}>
          {filteredTools?.slice(0, slicedTools)?.map(tool => (
            <Tool {...tool} key={tool?.name} />
          ))}
        </div>
        {isShowMoreVisible && (
          <Button
            tag={ButtonElementTypes.Button}
            skin={ButtonSkinTertiary}
            className={styles.button}
            data-pulse-name={buttonLabel}
            onClick={() => setSlicedTools(prev => prev + sliceLength)}
          >
            {translate(buttonLabel)}
          </Button>
        )}
      </HorizontalContainer>
    </section>
  );
}

export default AllTools;
